import ViewBase from "../../../../framework/core/mvvm/view_base";
import AppData from "../../../public/const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ActivityExtentView extends ViewBase {

  @property(cc.Node)
  dailyCode: cc.Node = null

  @property(cc.Node)
  appScore: cc.Node = null

  @property(cc.Node)
  bind: cc.Node = null

  @property(cc.EditBox)
  dailyCodeInput: cc.EditBox = null

  @property(cc.Button)
  scoreBtn: cc.Button = null

  @property([cc.Sprite])
  xingxing: cc.Sprite[] = []

  initView(activity) {
    this.dailyCode.active = activity == "code"
    this.appScore.active = activity == "score"
    this.bind.active = activity == "bind"
    this.dailyCodeInput.string = ""
  }
  initScoreView( score, localScore){
    this.scoreBtn.enabled = score > 0
    if (localScore > 0) {
      this.clickXing(localScore)
      this.scoreFinish()
    }
  }
  clickXing(index) {
    this.scoreBtn.enabled = true
    for (let i = 0; i < this.xingxing.length; i++) {
      this.xingxing[i].enabled = i < index
    }
  }
  scoreFinish() {
    this.scoreBtn.node.active = false
    for (let i = 0; i < this.xingxing.length; i++) {
      let btn = this.xingxing[i].node.getComponent(cc.Button)
      btn.enabled = false
    }
  }
}
